<template>

  <div class="landing-page">
   <!-- <star-banner></star-banner> -->

   <div class="row h-100 align-items-center text-center" >
      <div class="col-sm-12">
        <!-- Desktop logo -->
        <img class="logo d-none d-md-block mx-auto" src="/static/images/logo-white.png" />
        <h4 class="d-none d-md-block ml-8">{{ $t('message.landingPage.slogan') }}</h4>
        
        <!-- Mobile logo -->
        <img class="mobile-logo d-inline d-md-none" src="/static/images/Precisit-h-white-1600px.png" />
      </div>
    </div>
  </div>

</template>

<script>
import StarBanner from '@/components/shared/StarBanner';

export default {
  name: 'LandingPage',
  components: {
    StarBanner,
  },
  data() {
    return {
      title: 'Landing page',
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/main.scss';

.landing-page {
  background: fixed;
  background-image: url('/static/images/space_background/top-space-high.jpg'), url('/static/images/space_background/top-space-md.jpg'), url('/static/images/space_background/top-space-sm.jpg');
  background-position: left top, left top;
  background-repeat: no repeat, no-repeat;
  background-size: cover;
  height: 100vh;
  z-index: 0;
  h4 {
    font-weight: $font-weight-medium;
    @include breakpoint-font-size($h4-font-sizes);
    animation: appear_delayed 2s;
    color:white;
  }
}

.center {
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.logo {
  opacity: 0.95;
  width: 500px;
  @include media-breakpoint-up(xl) {
    width: 600px;
  }
}

.mobile-logo {
  width: 150px;
}

@keyframes appear_delayed {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
